export default "__VITE_ASSET__b5f34174__"